import { useApi } from '~shared/providers/use-api';

import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { Pos } from './pos';

import type { PosApi } from '../api';
import { POS_API_KEY } from '../api';

export function useGetPointsOfSalesQuery(options: UseQueryOptions<Pos[]> = {}) {
  const posApi = useApi<PosApi>(POS_API_KEY);

  return useQuery({
    queryKey: ['pos-list'],
    queryFn: async () => posApi.getPos(),
    ...options,
  });
}
